import { useMemo } from "react";
import { ELEVATED_SCHOOL_ADMIN_GROUP_NAME } from "src/constants";
import { Status } from "../types/authData";
import { HasuraRole } from "../types/hasuraRole";
import useUser from "./useUser";

export default function useCheckUserRole() {
  const user = useUser();

  const claims = user.status === Status.OK ? user.data : null;

  return useMemo(() => {
    let role = claims?.role;
    if (
      role === HasuraRole.ORG_ADMIN &&
      claims?.userGroup === ELEVATED_SCHOOL_ADMIN_GROUP_NAME
    ) {
      role = HasuraRole.SCHOOL_ADMIN;
    }

    return {
      isLoading: user.status === Status.LOADING,
      isUnauthenticated: user.status === Status.UNAUTHENTICATED,
      isAvelaAdmin: role === HasuraRole.ADMIN,
      isOrgAdmin: role === HasuraRole.ORG_ADMIN,
      isDistrictAdmin: role === HasuraRole.DISTRICT_ADMIN,
      isSchoolAdmin: role === HasuraRole.SCHOOL_ADMIN,
      isGuardian: role === HasuraRole.USER,
    };
  }, [claims?.role, claims?.userGroup, user.status]);
}
